<template>
  <div>
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">{{ this.$route.name }}</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item active"><i v-bind:class="routeIcon"></i> {{ $t(this.$route.name) }}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <section class="content">
      <div class="container-fluid">

        <div class="row col-lg-12">
          <div class="form-group col-sm-12">
            <EditForm :token="{}" mode="create" v-on:finish="this.handleItemsUpdate">Create</EditForm>
          </div>
        </div>

        <advanced-filters-wrapper
          :filters="filters"
          :default-values="{}"
          :expanded="true"
          :hide-advanced-btn="true"
          @onSearchClick="this.loadItems"
          @onResetClick="this.loadItems"
        ></advanced-filters-wrapper>

        <div class="row col-12" id="loading-container">
          <div class="col-12 mb-10">
            <div class="mb-10">
              <div class="table-wrapper mb-10">
                <ve-table class="text-nowrap"
                          :columns="columns"
                          :table-data="items"
                          :sort-option="sortOption"
                          :row-style-option="{ stripe: true }"
                          :border-around="true"
                          :border-x="true"
                          :border-y="true"
                />

                <div class="row mt-10">
                  <div class="col-6">
                  </div>
                  <div class="col-6">
                    <ve-pagination
                      :layout="['total', 'prev', 'pager', 'next']"
                      :page-index="pagination.page"
                      :page-size="pagination.onPage"
                      :total="pagination.count"
                      class="float-right"
                      @on-page-number-change="onPageChange"
                    />
                  </div>
                </div>

              </div>
              <div v-show="showEmpty" class="row mb-10 mt-10 empty-data">Empty results</div>
              <div v-show="showError" class="row mb-10 mt-10 empty-data">Failed</div>
            </div>

          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";
import {getRouteIcon, ROUTE_PARTNERS} from "../../utils/routerIcons";
import AdvancedFiltersWrapper from '../../components/AdvancedFiltersWrapper.vue';
import EditBrandTokenForm from '../../components/AltSsBrandToken/EditBrandTokenForm.vue';

function getDefaultPagination() {
  return {
    onPage: 25,
    page: 1,
    records: 0,
    count: 0,
    pageSizeOption: [25,50,100,200],
  };
}

function getDefaultSort() {
  return {
    column: 'brandId',
    order: 'ASC',
  };
}

export default {
  components: {
    AdvancedFiltersWrapper,
    EditForm: EditBrandTokenForm,
  },
  data() {
    return {
      showEmpty: false,
      showError: false,
      cancel: null,
      filterValues: {},
      filters: [
        {
          placeholder: '',
          label: 'Partner',
          inputId: 'partnerName',
          modelProp: 'partnerName'
        },
        {
          placeholder: '',
          label: 'Brand ID',
          inputId: 'brandId',
          modelProp: 'brandId'
        },
      ],
      columns: [
        {field: 'partnerName', title: 'Partner', align: 'left', sortBy: false, renderBodyCell: ({row}) => {
            return <span>{row.partnerName ? row.partnerName : <i class="text-muted">unknown</i>}</span>;
          }
        },
        {field: 'brandId', title: 'Brand ID', align: 'left', sortBy: true},
        {field: 'hasAltToken', title: 'Alt Token', align: 'center', sortBy: false, renderBodyCell: ({row}) => {
            return row.hasAltToken
              ? <i class="fas fa-check text-success" title="Set"></i>
              : <i class="fas fa-times text-danger" title="Not set"></i>;
          }
        },
        {field: 'hasAltSecret', title: 'Alt Secret', align: 'center', sortBy: false, renderBodyCell: ({row}) => {
            return row.hasAltSecret
              ? <i class="fas fa-check text-success" title="Set"></i>
              : <i class="fas fa-times text-danger" title="Not set"></i>;
          }
        },
        {field: 'actions', title: 'Actions', align: 'left', renderBodyCell: ({row}) => {return <span>
              <EditBrandTokenForm token={row} mode='edit' v-on:finish={this.handleItemsUpdate}></EditBrandTokenForm>
            </span>
          }
        },
      ],
      items: [],
      sortOption: {
        sortChange: (params) => {
          let sort = null;

          for (let i in params) {
            if (params[i] !== "") {
              sort = {
                column: i,
                order: params[i],
              };
            }
          }

          if (sort) {
            this.sorts = sort;
          } else {
            this.sorts = getDefaultSort();
          }

          this.page = 1;
          this.loadItems();
        },
      },
      sorts: getDefaultSort(),
      pagination: getDefaultPagination(),
    }
  },
  computed: {
    routeIcon: () => getRouteIcon(ROUTE_PARTNERS),
  },
  methods: {
    getFiltersSnapshot(filters) {
      return JSON.stringify({
        filters: filters,
        sorts: this.sorts,
      });
    },
    handleItemsUpdate() {
      this.loadItems();
    },
    loadItems(filters) {
      if (!filters) {
        filters = this.filterValues;
      }
      this.filterValues = filters;
      const filterSnapshot = this.getFiltersSnapshot(filters);

      if (this.lastResultFilterSnapshot !== filterSnapshot) {
        this.pagination.page = 1;
      }

      this.showEmpty = false;
      this.showError = false;

      let loadingInstance = this.$veLoading({
        target: document.querySelector("#loading-container"),
        name: "wave",
      });

      this.items = [];

      let self = this;
      loadingInstance.show();

      this
          .$http({
            url: '/api/v1/alt-ss-brand-tokens',
            params: {
              ...filters,

              // pagination
              limit: this.pagination.onPage,
              offset: this.pagination.onPage * (this.pagination.page - 1),

              // sort params
              orderBy: this.sorts.column,
              direction: this.sorts.order,
            },
            method: 'GET',
            cancelToken: new axios.CancelToken(function executor(c) {
              self.cancel = c;
            })
          })
          .then(resp => {
            let {items} = resp.data;

            this.items = items;
            this.pagination.onPage = resp.data.pagination.limit;
            this.pagination.count = resp.data.pagination.totalCount;

            if (this.items.length === 0) {
              this.showEmpty = true;
            }

            this.lastResultFilterSnapshot = filterSnapshot;
          })
          .catch((err) => {
            console.log(err);
            this.items = [];
            this.showError = true;
          })
          .finally(() => {
            loadingInstance.close();
            this.cancel = null;
          });
    },
    onPageChange(page) {
      this.pagination.page = page;
      this.loadItems()
    },
  },
  mounted() {
    this.loadItems();
  }
}
</script>
